import _ from 'lodash';
import Base from './base';

export default class ProductType extends Base {
    static fields = {
        name: String,
    }
    static relations = {
        oneToMany: ['unit'],
        manyToMany: ['suppliers', 'manufacturers']
    }

    static searchConfig = [{
        icon: 'mdi-format-text',
        label: 'Naam',
        type: 'property',
        filter: 'name'
    },
    {
        icon: 'mdi-format-text',
        label: 'Type',
        type: 'distinct',
        filter: 'type',
        settings: {
            module: 'productTypes'
        }
    },
    {
        icon: 'mdi-format-text',
        label: 'Modelnummer',
        type: 'property',
        filter: 'code'
    },
    {
        icon: 'mdi-format-text',
        label: 'Artikelnummer',
        type: 'property',
        filter: 'supplierCode'
    },
    ];

    getSaveData() {
        const data = super.getSaveData();

        if (data.hasOwnProperty('measurementTypes')) {
            for (let j = 0; j < data['measurementTypes'].length; j++) {
                data['measurementTypes'][j] = {
                    id: data['measurementTypes'][j].id,
                    settings: data['measurementTypes'][j]?.settings?.map(item => ({ ...item, value: parseFloat(item.value) }))
                }
            }
        }

        if (data.hasOwnProperty('taskTypeConfig')) {
            if (data.taskTypeConfig) {
                data.taskTypeConfig = data.taskTypeConfig.map(item => ({
                    id: item.id || undefined,
                    taskTypeId: item.taskType?.id,
                    jobTypeId: item.jobType?.id || null,
                    variant: item.variant || null
                }));
            }
        }

        return data;

    }
}